/* eslint-disable import/prefer-default-export */
import axios from 'axios';

import { getAuthTokenFromStorage } from '../utils';
import { getServerUrl } from '../constants';

const SUBROUTE = 'national-topic';

/**
 * @description gets all national topics
 * @returns {Promise<Object>} API response
 */
export const fetchAll = async () => {
  if (!global.API_URL) {
    global.API_URL = getServerUrl();
  }

  const url = `${global.API_URL}/${SUBROUTE}`;

  try {
    const { data: { data } } = await axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * @description sets all new national topics
 * @param {Object} topics new national topic objects
 */
export const setNewNationalTopics = async (topics) => {
  const url = `${global.API_URL}/${SUBROUTE}/new`;
  const token = getAuthTokenFromStorage();

  try {
    const { data: { data } } = await axios.post(url, topics, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
